module.exports = __webpack_public_path__ + "media/images/result_sets/circles/4n3r1r2r-8b3c9a06b55d7eaa32647d36f9538272.svg";